import { City } from "./city.model"
import { Country } from "./country.model"

export class State {
    ID?: number
    COUNTRIES_ID?: number
    STATE_NAME?: string
    STATE_CODE?: string
    CREATED_BY?: string
    CREATED_DATE?: Date
    MODIFIED_BY?: string
    MODIFIED_DATE?: Date

    COUNTRy?: Country
    CITIES?: City
}
